const textArea = document.querySelectorAll('.textarea-with-counter');

textArea.forEach((textarea) => {
  const parentElement = textarea.closest('.mod-input');
  textarea.addEventListener('input', (input) => {
    const characterCountElement = parentElement.querySelector('.mod-input__curr-character');
    characterCountElement.textContent = `${input.target.value.length}`;
  });
});

// *******************************************************************************
// Letters and numbers validation
// *******************************************************************************

const numbersFields = [
  ...document.querySelectorAll('[data-digits-only]'),
  ...document.querySelectorAll('input[type="number"]'),
];

numbersFields.forEach((input) => {
  input.addEventListener('input', (event) => {
    const inputValue = event.target.value;
    event.target.value = inputValue.replace(/(?!^\+)\D/g, '');
  });
});
